import React from 'react';
import styles from './error.module.scss';
import { useTranslation } from 'react-i18next';
import SecondaryButton from '../buttons/SecondaryButton';
import ErrorSupportLink from './ErrorSupportLink';
import FeatherIcon from "feather-icons-react";

interface IProps {
  code?: string,
  redirectUrl?: string
  finishConnection: () => void,
}

const RevocationError: React.FC<IProps> = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.screen} data-testid='error-container'>
      <div className={styles.topWrapper}>
          <FeatherIcon icon="alert-triangle" className={styles.icon} />
        <h1>{t<string>('Unable to revoke consent')}</h1>
        <div className={styles.content}>
          <p>{t<string>('Sorry, we are unable to revoke your consent at this time.')}</p>
          <p>{t<string>('Please try again later')}</p>
          <p><>{t<string>('If the problem persists, please contact our')} <ErrorSupportLink errorCode={props.code} /></></p>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        {(props.redirectUrl || window.opener != null) && (
          <SecondaryButton onClick={props.finishConnection}>
            {props.redirectUrl ? t<string>('Continue') : t<string>('Close window')}
          </SecondaryButton>
        )}
      </div>
    </div>
  );
};

export default RevocationError;
